import { render } from "./CommonFooter.vue?vue&type=template&id=a7df053c"
import script from "./CommonFooter.vue?vue&type=script&lang=js"
export * from "./CommonFooter.vue?vue&type=script&lang=js"

import "./CommonFooter.vue?vue&type=style&index=0&id=a7df053c&lang=css"

import exportComponent from "/var/www/html/menejar/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__